/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ListInvoices200ResponseItemsInnerCurrencyCode } from './ListInvoices200ResponseItemsInnerCurrencyCode';
import {
    ListInvoices200ResponseItemsInnerCurrencyCodeFromJSON,
    ListInvoices200ResponseItemsInnerCurrencyCodeFromJSONTyped,
    ListInvoices200ResponseItemsInnerCurrencyCodeToJSON,
    ListInvoices200ResponseItemsInnerCurrencyCodeToJSONTyped,
} from './ListInvoices200ResponseItemsInnerCurrencyCode';
import type { ListInvoices200ResponseItemsInnerLocationsInner } from './ListInvoices200ResponseItemsInnerLocationsInner';
import {
    ListInvoices200ResponseItemsInnerLocationsInnerFromJSON,
    ListInvoices200ResponseItemsInnerLocationsInnerFromJSONTyped,
    ListInvoices200ResponseItemsInnerLocationsInnerToJSON,
    ListInvoices200ResponseItemsInnerLocationsInnerToJSONTyped,
} from './ListInvoices200ResponseItemsInnerLocationsInner';

/**
 * 
 * @export
 * @interface ListInvoices200ResponseItemsInner
 */
export interface ListInvoices200ResponseItemsInner {
    /**
     * 
     * @type {string}
     * @memberof ListInvoices200ResponseItemsInner
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ListInvoices200ResponseItemsInner
     */
    customerId: string;
    /**
     * 
     * @type {string}
     * @memberof ListInvoices200ResponseItemsInner
     */
    externalId?: string;
    /**
     * 
     * @type {Date}
     * @memberof ListInvoices200ResponseItemsInner
     */
    creationTime: Date;
    /**
     * 
     * @type {Date}
     * @memberof ListInvoices200ResponseItemsInner
     */
    sendingTime?: Date;
    /**
     * 
     * @type {number}
     * @memberof ListInvoices200ResponseItemsInner
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof ListInvoices200ResponseItemsInner
     */
    pendingAmount: number;
    /**
     * 
     * @type {ListInvoices200ResponseItemsInnerCurrencyCode}
     * @memberof ListInvoices200ResponseItemsInner
     */
    currencyCode: ListInvoices200ResponseItemsInnerCurrencyCode;
    /**
     * 
     * @type {string}
     * @memberof ListInvoices200ResponseItemsInner
     */
    invoiceNumber: string;
    /**
     * 
     * @type {string}
     * @memberof ListInvoices200ResponseItemsInner
     */
    status: ListInvoices200ResponseItemsInnerStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof ListInvoices200ResponseItemsInner
     */
    type: ListInvoices200ResponseItemsInnerTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ListInvoices200ResponseItemsInner
     */
    refusalReason?: string;
    /**
     * 
     * @type {Array<ListInvoices200ResponseItemsInnerLocationsInner>}
     * @memberof ListInvoices200ResponseItemsInner
     */
    locations?: Array<ListInvoices200ResponseItemsInnerLocationsInner>;
}


/**
 * @export
 */
export const ListInvoices200ResponseItemsInnerStatusEnum = {
    Paid: 'paid',
    Pending: 'pending',
    NonRetrying: 'non-retrying',
    Processing: 'processing'
} as const;
export type ListInvoices200ResponseItemsInnerStatusEnum = typeof ListInvoices200ResponseItemsInnerStatusEnum[keyof typeof ListInvoices200ResponseItemsInnerStatusEnum];

/**
 * @export
 */
export const ListInvoices200ResponseItemsInnerTypeEnum = {
    Subscription: 'subscription',
    Commission: 'commission',
    HardwareStore: 'hardware-store',
    Installation: 'installation',
    ChargeBack: 'charge-back',
    Unknown: 'unknown',
    Subsidy: 'subsidy'
} as const;
export type ListInvoices200ResponseItemsInnerTypeEnum = typeof ListInvoices200ResponseItemsInnerTypeEnum[keyof typeof ListInvoices200ResponseItemsInnerTypeEnum];


/**
 * Check if a given object implements the ListInvoices200ResponseItemsInner interface.
 */
export function instanceOfListInvoices200ResponseItemsInner(value: object): value is ListInvoices200ResponseItemsInner {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('customerId' in value) || value['customerId'] === undefined) return false;
    if (!('creationTime' in value) || value['creationTime'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('pendingAmount' in value) || value['pendingAmount'] === undefined) return false;
    if (!('currencyCode' in value) || value['currencyCode'] === undefined) return false;
    if (!('invoiceNumber' in value) || value['invoiceNumber'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function ListInvoices200ResponseItemsInnerFromJSON(json: any): ListInvoices200ResponseItemsInner {
    return ListInvoices200ResponseItemsInnerFromJSONTyped(json, false);
}

export function ListInvoices200ResponseItemsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListInvoices200ResponseItemsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'customerId': json['customerId'],
        'externalId': json['externalId'] == null ? undefined : json['externalId'],
        'creationTime': (new Date(json['creationTime'])),
        'sendingTime': json['sendingTime'] == null ? undefined : (new Date(json['sendingTime'])),
        'total': json['total'],
        'pendingAmount': json['pendingAmount'],
        'currencyCode': ListInvoices200ResponseItemsInnerCurrencyCodeFromJSON(json['currencyCode']),
        'invoiceNumber': json['invoiceNumber'],
        'status': json['status'],
        'type': json['type'],
        'refusalReason': json['refusalReason'] == null ? undefined : json['refusalReason'],
        'locations': json['locations'] == null ? undefined : ((json['locations'] as Array<any>).map(ListInvoices200ResponseItemsInnerLocationsInnerFromJSON)),
    };
}

export function ListInvoices200ResponseItemsInnerToJSON(json: any): ListInvoices200ResponseItemsInner {
    return ListInvoices200ResponseItemsInnerToJSONTyped(json, false);
}

export function ListInvoices200ResponseItemsInnerToJSONTyped(value?: ListInvoices200ResponseItemsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'customerId': value['customerId'],
        'externalId': value['externalId'],
        'creationTime': ((value['creationTime']).toISOString()),
        'sendingTime': value['sendingTime'] == null ? undefined : ((value['sendingTime']).toISOString()),
        'total': value['total'],
        'pendingAmount': value['pendingAmount'],
        'currencyCode': ListInvoices200ResponseItemsInnerCurrencyCodeToJSON(value['currencyCode']),
        'invoiceNumber': value['invoiceNumber'],
        'status': value['status'],
        'type': value['type'],
        'refusalReason': value['refusalReason'],
        'locations': value['locations'] == null ? undefined : ((value['locations'] as Array<any>).map(ListInvoices200ResponseItemsInnerLocationsInnerToJSON)),
    };
}

